import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useMembersStore } from '../store/membersStore'
import { addMember } from '../utils/addMember'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'
import { DONATIONS } from '@/features/donations/constants/endpoints'

export const useAddMemberMutation = (onSuccess?: () => void) => {
  const add = useMembersStore((state) => state.add)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addMember,
    onSuccess: ({ message, member, hadUpdatedDonations }) => {
      add(member)

      if (hadUpdatedDonations) {
        queryClient.invalidateQueries({ queryKey: [DONATIONS] })
      }

      toast.success(message || 'Member created successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while creating member.')
    },
  })
}
